<template>
  <div>
<!--     <p>aaaa</p> -->
    <span>{{ age }}</span>
  </div>
</template>

<script>
export default {
  name: 'CellRendererAge',
  computed: {
    age () {
      const date = new Date;
      if(this.params.data.birthday)
        return (date.getFullYear()-Number(this.params.data.birthday.split('-')[0]))
      return ('')
    }
  }
}
</script>
